import React, { useState } from 'react';
import './FaqQue.css';

const faqData = [
  {
    question: "Whether and how a thermal imaging can identify and differentiate a tumor swelling and inflammatory swelling?",
    answer: "Tumor swelling – shows increase in temp. by 0.5 to 3 degrees and the temp. will not reduce by cold stress test due to the absence of receptors in the neovasculature of the tumor. Whereas in the inflammatory swellings / lesions the vessel will constrict by cold stress test.",
  },
  {
    question: "Whether in tumor swelling the benign and malignant can be differentiated?",
    answer: "No – it cannot be differentiated.",
  },
  {
    question: "Interpretation of this is on what basis, any range of temperature or difference in colour or any other parameter?",
    answer: "Temperature difference is seen by the color as per the band in the picture frame with the temperature for each color. Further, the temperature grid will give you the exact temperature graph in the lesion.",
  },
  {
    question: "Normal and abnormal range of temperature and colour indicator in normal and diseased?",
    answer: "Yes, it can be differentiated with pre and post-processing of the images by the machine operator and the Thermologist doing the study.",
  },
  {
    question: "What is its significance in identifying a disease and how is it compared or unique with other diagnostic imaging such as USG, CT, and MRI other than non-invasiveness and radiation safety?",
    answer: "It has no radiation hazard. The study is contactless with the patient and machine. It is very simple, painless, and takes a short time to perform. It is portable and can be installed with just 5 amps electrical. Images can be stored, processed, and sent by email to concerned people from a laptop. Newer machines and software provide more details and sharper images.",
  },
  {
    question: "Whether it will overdiagnose or under diagnose a condition and its reliability in disease identification?",
    answer: "Its reliability is as of now is 85 to 90% specificity and 90 to 95 % sensitivity.",
  },
  {
    question: "How Infrared complements a clinical examination in identification of pathology?",
    answer: "Infrared is a complementary examination or study to other imaging modalities to assist the clinician to diagnose at an early stage, so that it is a precautionary study to make the medical fraternity aware of the pathology at an early stage.",
  },
  {
    question: "Limitations in diagnosing a disease, advantage and disadvantage",
    answer: "It has its limitations as the IR camera can detect the temperature variations up to a depth of 4 – 7 cms from the skin. Deeper structures can be studied with minimum accuracy as of now, with the available machines and software.",
  },
  {
    question: "Difference in midgreen, iron, grey mode of imaging and ideal mode for interpretation?",
    answer: "It is the operator's choice to choose his color combination and his ability to identify the colors by his visual acuity in color differentiation of the lesions and normal tissues.",
  },
  {
    question: "Thermal image in parotid region – clinical significance in identifying the disease?",
    answer: "It is very superficial so we can do a proper study of the parotid gland. Inflammation and other diseases can be differentiated by the alternative methods of study with Infrared.",
  },
  {
    question: "Hot and cold spot, hypothermia, hyperthermia and normal Infrared, differentiation of this in different origins?",
    answer: "The interpretation of the images depends on the method of study and also the patterns of the images, colors and other stress tests done during the procedure.",
  },
  {
    question: "How to differentiate a swelling in parotid by Infrared – acute, chronic parotitis or sialadenitis, Sjogren's, benign, malignant, sialadenosis, sialolithiasis, or other causes of enlargement?",
    answer: "The variations of the lesion size, number, temperature differentiation in the lesion, surrounding the lesion, vasculature response to cold stress test and other parameters during the study can, to a certain extent, give you the exact diagnosis. Along with Infrared, we need other imaging modalities to come to a diagnosis for further management. This study only aids in locating the lesion and also the extent of involvement of the disease.",
  },
];

const FaqQue = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFaq = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="container faq-section">
      <h2 className="mb-4">FAQ</h2>
      <div className="accordion">
        {faqData.map((item, index) => (
          <div key={index} className="panel panel-default">
            <div className="panel-heading text-black text-start">
              <h4 className="panel-title text-black text-start">
                <a 
                  onClick={() => toggleFaq(index)} 
                  style={{ cursor: 'pointer' }}>
                  {index + 1}. {item.question}
                </a>
              </h4>
            </div>
            {openIndex === index && (
              <div className="panel-body">
                {item.answer}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default FaqQue;
